module.exports = __webpack_public_path__ + "img/69.764fb83a.jpg";